import { CheckCircle, Lightning, List, X } from "@phosphor-icons/react";
import { useEffect, useRef, useState } from "react";
import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import { track } from "../lib/analytics";
import { TOAST_EVENT } from "../lib/toast";

export function AppShell() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [toast, setToast] = useState("");
  const location = useLocation();
  const opened = useRef(false);

  useEffect(() => {
    if (!opened.current) {
      opened.current = true;
      track("app_opened", { view: routeName(location.pathname) });
    }
    if (location.pathname === "/about") track("methodology_opened", { view: "about" });
  }, [location.pathname]);

  useEffect(() => {
    let timer = 0;
    const handleToast = (event: Event) => {
      setToast((event as CustomEvent<string>).detail);
      window.clearTimeout(timer);
      timer = window.setTimeout(() => setToast(""), 2600);
    };
    window.addEventListener(TOAST_EVENT, handleToast);
    return () => {
      window.removeEventListener(TOAST_EVENT, handleToast);
      window.clearTimeout(timer);
    };
  }, []);

  return (
    <div className="min-h-dvh bg-canvas text-ink">
      <a className="skip-link" href="#main-content">Skip to content</a>
      <header className="site-header">
        <div className="page-shell header-inner">
          <Link className="wordmark" to="/" aria-label="Watt It Costs home">
            <span className="wordmark-mark" aria-hidden="true"><Lightning weight="fill" /></span>
            <span>Watt It Costs</span>
          </Link>
          <button
            className="icon-button mobile-menu-button"
            type="button"
            aria-expanded={menuOpen}
            aria-controls="primary-navigation"
            aria-label={menuOpen ? "Close navigation" : "Open navigation"}
            onClick={() => setMenuOpen((open) => !open)}
          >
            {menuOpen ? <X /> : <List />}
          </button>
          <nav id="primary-navigation" className={menuOpen ? "site-nav is-open" : "site-nav"} aria-label="Primary navigation">
            <NavLink to="/" end onClick={() => setMenuOpen(false)}>Explore</NavLink>
            <NavLink to="/compare" onClick={() => setMenuOpen(false)}>Compare</NavLink>
            <NavLink to="/about" onClick={() => setMenuOpen(false)}>Methodology</NavLink>
          </nav>
        </div>
      </header>
      <main id="main-content"><Outlet /></main>
      <div className={toast ? "toast is-visible" : "toast"} role="status" aria-live="polite" aria-atomic="true">
        <CheckCircle weight="fill" aria-hidden="true" /> {toast}
      </div>
      <footer className="site-footer">
        <div className="page-shell footer-inner">
          <p>Published tariff information for public understanding.</p>
          <p>Estimates may differ from your bill. Verify with your supplier.</p>
        </div>
      </footer>
    </div>
  );
}

function routeName(pathname: string) {
  if (pathname.startsWith("/m/")) return "municipality";
  if (pathname.startsWith("/a/")) return "authority";
  if (pathname === "/compare") return "compare";
  if (pathname === "/about") return "about";
  return "explorer";
}
